import { useContext, useState } from "react";
import { AuthContext } from "../context/authContext";
import axios from "axios";
import { baseUrl } from "../modules/account/login";
import { useNavigate } from "react-router";
import { keepPreviousData, useQuery } from "@tanstack/react-query";

export default function useAppointments() {
  const { token } = useContext(AuthContext);
  const AuthStr = "Bearer ".concat(token);
  const [loading, setLoading] = useState(true);
  const navigate = useNavigate();

  const getData = () => {
    return axios
      .get(`${baseUrl}/appointments/get_appointments`, {
        headers: { Authorization: AuthStr },
      })
      .then((response) => {
        const data = response?.data;
        setLoading(false);
        return Object.values(data?.data).filter(
          (arr) => Array.isArray(arr) && arr.length > 0
        );
      })
      .catch((e) => {
        if (e?.response?.data?.message === "Session expired")
          navigate("/account/logout");
        return Promise.reject(
          new Error(e?.message ?? "Check your internet connection")
        );
      });
  };

  const { data, error, isLoading, refetch } = useQuery({
    queryKey: ["appointments", token],
    queryFn: () => getData(),
    placeholderData: keepPreviousData,
  });

  return { data, error, isLoading, loading, refetch };
}
